import EditIcon from "assets/icon/EditIcon";

export default function GridEditButton({ onClick, isActive, size='w-4' }) {
    return (
        <button className={`bg-black rounded-lg p-2 flex gap-2 ${isActive === '1' ? '' : 'hidden'}`} onClick={onClick}>
            <EditIcon className={`${size} fill-white`} />
        </button>
    )
}